import React, { useEffect } from "react";
import PackageBundleItem from "./PackageBundleItem";
import { useProductData } from "../../zustand/productStore";
import { useMarketingStore } from "../../zustand/emailMarketingStore";
import { ProductPackageItem } from "./ProductPackageItem";
import { useCartData } from "../../zustand/cartStore";
import getDefaultVariantsState from "../../func/defaultVariants";

const ProductsList = ({ bundles }) => {
  const { setSelectedProduct, selectedProduct, setVariants, setWarrantyState } = useCartData();
  const { freeShippingApplied } = useMarketingStore();
  const productData = useProductData();

  //   set default product product && variants if variants exists

  useEffect(() => {
    if (productData?.products) {
      const defaultProductIndex = productData?.products?.findIndex((item) => {
        return item.best_seller == true;
      });
      const enableVariants = productData?.enable_color_variants || productData?.enable_size_variants;
      if (enableVariants) {
        const variantsState = getDefaultVariantsState(productData);
        setVariants(variantsState);
      }
      if (productData?.preselect_warranty) {
        setWarrantyState(true);
      }

      const defaultProduct = defaultProductIndex
        ? productData?.products[defaultProductIndex]
        : productData?.products[0];

      handleChange(defaultProduct);
    }
  }, [productData?.products]);

  useEffect(() => {
    if (freeShippingApplied) {
      productData.changeProductsShippingPrice(0);
    }
  }, [freeShippingApplied]);

  const handleChange = (product) => {
    setSelectedProduct({
      sku: product.sku,
      amount: product.amount,
      konnektive_id: product.konnektive_id,
      bundle_products: product.bundle_products,
      warranty_price: product.warranty_price,
      warranty_product_id: product.warranty_product_id,
      display_name: product.display_name,
      generic_name: product.generic_name,
      bundle_title: product.bundle_title,
      price: product.price,
      old_price: product.old_price,
      shipping_price: product.shipping_price,
      promo_discounted_price: product.promo_discounted_price,
      promo_shipping_price: product.promo_shipping_price,
      fake_products: product.fake_products,
    });
  };

  return (
    <>
      {productData?.products &&
        productData?.products.map((product, i) => {
          if (bundles) {
            return (
              <PackageBundleItem
                key={i}
                product={product}
                handleChange={() => handleChange(product)}
                active={selectedProduct?.price === product?.price}
                index={i}
              />
            );
          } else {
            return (
              <ProductPackageItem
                key={i}
                product={product}
                handleChange={() => handleChange(product)}
                active={selectedProduct?.price === product?.price}
                index={i}
              />
            );
          }
        })}
    </>
  );
};

export default ProductsList;
